import Api from '../http.service';

/**
 * @param {String} profileId
 */
export const getByProfileId = (profileId) =>
  Api.GET({ url: `signiture/profile/${profileId}` });

/**
 * update
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data._id
 * @param {string} payload.data.profileId
 * @param {string} payload.data.gatewayId
 * @param {Array} payload.data.signiture
 */
export const update = (payload) =>
  Api.PUT({ url: 'signiture', data: payload.data });

/**
 * insert signiture
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.profileId
 * @param {string} payload.data.gatewayId
 * @param {Array} payload.data.signiture
 */
export const insert = (payload) =>
  Api.POST({ url: 'signiture', data: payload.data });
/**
 * insertORupdate signiture
 * @param {object} payload
 * @param {string} payload.method
 * @param {object} payload.data
 * @param {string} payload.data.profileId
 * @param {string} payload.data.gatewayId
 * @param {Array} payload.data.signiture
 */
export const updateORinsert = (payload) =>
  payload.method === 'POST'
    ? Api.POST({ url: 'signiture', data: payload.data })
    : payload.method === 'PUT' &&
      Api.PUT({ url: 'signiture', data: payload.data });
